import _ from "lodash";
import Logger from "./logger.js";

const staticEvents = ["MachineStatusChanged"];
export default class Listener {
  constructor(streamApi, emitter, vuex = {}) {
    this.streamApi = streamApi;
    this.emitter = emitter;
    this.store = vuex.store;

    this.subscribeStoreMutations();
  }

  subscribeStoreMutations() {
    if (this.store) {
      this.storeUnSubscription = this.store.watch(
        (state, getters) => getters["Machine/getMachinesRaw"],
        (newValue, oldValue) => {
          if (!newValue || Object.keys(newValue).length === 0) {
            Logger.info(`UnSubscribe, payload:`, newValue);
            this.unsubscribeMachines();
          } else if (
            !_.isEqual(Object.keys(newValue || {}).sort(), Object.keys(oldValue || {}).sort())
          ) {
            Logger.info(`Subscribe #Machine/getMachinesRaw mutation, payload:`, newValue);
            this.subscribeMachines(newValue);
          }
        }
      );
    }
  }

  subscribeMachines(machines) {
    if (machines) {
      const identifiers = Object.values(machines).map(el => {
        return {
          id: el.Id,
          events: staticEvents
        };
      });

      for (const identifier of identifiers) {
        this.registerIdentifier(identifier);
      }
    }
  }

  registerIdentifier(identifier) {
    if (!this.identifiers) {
      this.identifiers = {};
    }

    if (identifier && !this.identifiers[identifier.id]) {
      this.identifiers[identifier.id] = identifier;

      for (const eventName of identifier.events) {
        this.streamApi.subscribe(identifier.id, eventName, event => {
          this.onEvent(eventName, event);
        });
      }
    }
  }

  unsubscribe() {
    if (this.storeUnSubscription) {
      this.storeUnSubscription();
    }
    this.storeUnSubscription = undefined;

    this.unsubscribeMachines();
  }

  unsubscribeMachines() {
    if (this.identifiers) {
      for (const identifier of Object.values(this.identifiers)) {
        this.unsubscribeIdentifier(identifier);
      }
      this.identifiers = {};
    }
  }

  unsubscribeIdentifier(identifier) {
    if (identifier) {
      for (const eventName of identifier.events) {
        this.streamApi.unsub(identifier.id, eventName);
      }
    }
  }

  /**
   * Broadcast all events to vuejs environment
   */
  onEvent(event, args) {
    this.emitter.emit(event, args);
  }
}
